<template>
  <div class="second-bar-admin">
    <v-tabs class="task-tab" ref="tabs">
      <v-tab ref="tab">
        <span style="color: black; font-weight: bold">Tất cả ({{totalSuccessTask}}/{{tasks.count ? tasks.count : 0}})</span>
      </v-tab>
      <v-tab-item>
        <ListCreatedTask @recountTotalSuccess="getTotalSuccessTask" @show-modal-quick-view="showQuickView" class="mt-4" :tasks="tasks.tasks" :filter-form="filterForm"></ListCreatedTask>
      </v-tab-item>
    </v-tabs>
    <modal-quick-view
      v-if="isOpenQuickView"
      :isShow="isOpenQuickView"
      :contact="selectedContact"
      :contactId="selectedContactId"
      :id="selectedItemId"
      :filter-form.sync="filterForm"
      :dataContact="dataContact"
      :contactStatusList="contactStatusList"
      :routine-student-id="selectedRoutineStudentId"
      :homeroomTeacherName="homeroomTeacherName"
      :homeroomTeacher="homeroomTeacher"
      :levels="levels"
      @closeModalQuickView="closeModalQuickView()"
    />
  </div>
</template>

<script>
import ModalQuickView from '@/modules/student_care/components/ModalQuickView.vue';
import ListCreatedTask from '@/components/trigger_task/ListCreatedTask.vue';
import { mapState } from 'vuex';
import { LEVELS } from '@/modules/student_care/store/mutation-types';
import TaskRepository from '@/services/TaskRepository';

export default {
  name: 'BlendedTaskTable',
  props: {
    filterForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      totalSuccessTask: 0,
      homeroomTeacherName: '',
      homeroomTeacher: {},
      contactStatusList: [],
      selectedItemId: 0,
      selectedRoutineStudentId: 0,
      isOpenQuickView: false,
      selectedContactId: 0,
      selectedContact: null,
      dataContact: {},
      levels: LEVELS,
    };
  },
  components: { ListCreatedTask, ModalQuickView },
  computed: {
    ...mapState('blended', ['tasks']),
  },
  created() {
    Bus.$on('recountTotalSuccess', () => {
      this.recountTotalSuccess();
    });
  },
  async mounted() {
    this.resizeTab();
    await this.getTotalSuccessTask();
  },
  methods: {
    async recountTotalSuccess() {
      this.resizeTab();
      await this.getTotalSuccessTask();
    },
    resizeTab() {
      const interval = setInterval(() => {
        if (this.$refs.tab) {
          this.$refs.tabs.callSlider();
        }
      }, 200);
      setTimeout(() => {
        clearInterval(interval);
      }, 4000);
    },
    async getTotalSuccessTask() {
      const innerFilterForm = _.cloneDeep(this.filterForm);
      innerFilterForm.phoneNumber = innerFilterForm.mobile;
      const result = await TaskRepository.getTotalSuccessTask(innerFilterForm);
      if (result.message === 'Success') {
        this.totalSuccessTask = result.data[0].completeCount;
      }
    },
    showQuickView(item) {
      this.selectedContact = item;
      this.selectedContactId = item.contact_id;
      this.selectedCustomerId = item.lms_core_user_id;
      this.selectedRoutineStudentId = item.id;
      this.homeroomTeacher = { id: item.homeroom_teacher_id, name: item.homeroom_teacher_name };
      this.selectedItemId = item.id;
      setTimeout(() => {
        this.isOpenQuickView = true;
      }, 0);
    },
    closeModalQuickView() {
      this.isOpenQuickView = false;
      this.selectedContactId = 0;
    },
  },
  destroyed() {
    Bus.$off('recountTotalSuccess');
  },
};
</script>

<style>
.second-bar-admin {
  margin-top: 28px;
  margin-bottom: 28px;
}
.task-tab .v-tabs-bar{
  background: none !important;
}
.task-tab .v-tab {
  box-shadow: 0px 4px 4px 0px #00000040;
  font-size: 12px;
}
.task-tab .v-tab.v-tab--active {
  background: white;
  /*box-shadow: 0px 4px 4px 0px #00000040;*/
  color: #4D4CAC;
}
.task-tab .v-tab.v-tab--active .total-record-box {
  background: #4D4CAC;
}
.task-tab .v-tabs-slider-wrapper {
  top: 0;
  height: 5px !important;
}
.task-tab .v-tabs-slider-wrapper .v-tabs-slider {
  border-radius: 4px 4px 0 0;
  background: #4D4CAC;
}
</style>
